import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import map from '../assets/images/bitmap.png';

const mapStateToProps = ({ settings }) => {
  return {
    settings
  };
};

const actions = {};

const mapDispatchToProps = (dispatch) => {
  return { actions: bindActionCreators(actions, dispatch) };
};
class Footer extends Component {
  renderAddressInfo = (data) => {
    const { address, tel, email } = data;
    return (
      <div className="m-bottom-10">
        {address && (
          <p className="lightBlue">{address}</p>
        )}
        {tel && (
          <a href={`tel:${tel}`}>
            <p className="lightBlue">{tel}</p>
          </a>
        )}
        {email && (
          <p className="lightBlue">{email}</p>
        )}
      </div>
    );
  }

  render() {
    const { settings, getContentLanguage } = this.props;
    const graphicImage = _.get(settings, 'graphic_map.url', map);
    return (
      <footer className="footer">
        <div className="row no-gutters">
          <div className="more-info block col-12 order-3 col-lg-4 order-lg-1">
            <div className="more-info-content offset-0 col-12 offset-sm-1 col-sm-10 offset-lg-3 col-lg-8">
              <h2 className="navGold m-bottom-40">
                {`${getContentLanguage('moreInformation')}`}
              </h2>
              <a
                href={_.get(settings, ['basic_catalog', 'url'])}
                className="nav navGold"
                rel="noopener noreferrer"
                target="_blank"
              >
                <h4 className="m-bottom-20">
                  {getContentLanguage('downloadCatalog')}
                </h4>
              </a>
              <Link to="/contact" className="">
                <h4 className="nav navGold m-bottom-20">
                  {getContentLanguage('faq')}
                </h4>
              </Link>
              <div className="row social no-gutters">
                <a href={`tel:${_.get(settings, 'tel')}`}>
                  <i className="icon-phone" />
                </a>
                <a href={`mailto:${_.get(settings, 'email')}`}>
                  <i className="icon-mail" />
                </a>
                <a href={`http://line.me/ti/p/~${_.get(settings, 'line')}`}>
                  <i className="icon-line" />
                </a>
              </div>
            </div>
          </div>
          <div className="address block col-12 order-2 col-lg-3 order-lg-2">
            <div className="address-content col-12 offset-sm-1 col-sm-10 no-gutters">
              <h2 className="lightBlue m-top-20 m-bottom-20">
                {getContentLanguage('address')}
              </h2>
              {this.renderAddressInfo(settings)}
              {_.map(_.get(settings, 'other_contact', []), (data) => {
                return this.renderAddressInfo(data);
              })}
            </div>
          </div>
          <div className="map col-12 order-1 col-lg order-lg-3">
            <a href={_.get(settings, 'google_map', '#')} target="_blank" rel="noopener noreferrer">
              <img src={graphicImage} alt="map" />
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js